// import { crypto_secret } from '../../config'
import { EntityActions } from '../common/base/entity'
// import {EntityComponent} from '../entity'

export class mailServerAction extends EntityActions {
	constructor(options) {
		super(options)
		// this.simpleCrypto = new SimpleCrypto()
	}

	preActionsHooks({ actionName, item }) {
		if (!item || Object.keys(item).length === 0) return
		if ((item && actionName == 'addNewItem') || actionName == 'editItem' || actionName == 'publishItem' || actionName == 'testConnection' ) {
			let payload = { ...item }
			if (!payload.portNo) payload.portNo = 993
			if (!payload.timeOut) payload.timeOut = 10000
			if (!payload.status && actionName === 'publishItem' || actionName === 'testConnection' ) payload.status = 'Published'
			else if (!payload.status) payload.status = 'Draft'
			else if ((payload.status === 'Published' || payload.status === 'Draft') && actionName === 'editItem') payload.status = 'Deleted'
			else if (payload.status === 'Draft' && actionName === 'testConnection') payload.status = 'Published'
			if (!payload.delimiter) payload.delimiter = ','
			let removeObjectProperties = function (obj, props) {
				for (var i = 0; i < props.length; i++) {
					if (obj.hasOwnProperty(props[i])) {
						delete obj[props[i]]
					}
				}
			}
			let hashedPassword = item && item.password
			let properties = {
				authType: item.authType,
				protocol: item.protocol && item.protocol,
				hostName: item.hostName && item.hostName,
				portNo: payload.portNo && payload.portNo,
				timeOut: payload.timeOut || 10000,
				queueName: item.queueName && item.queueName,
				team: item.team,
				multiItem: item.multiItem,
				exclusionSubject: item.exclusionSubject || '/^((?!autoreply|ooo).)*$/g',
				folderMapping: item.folderMapping,
				caseFieldsMapping: item.caseFieldsMapping,
				priorityMapping: item.priorityMapping,
				// successFolder: item.successFolder && item.successFolder,
				// failedFolder: item.failedFolder && item.failedFolder,
				// reProcessFolder: item.reProcessFolder && item.reProcessFolder,
				// domain: item.domain && item.domain,
				// category: item.category && item.category,
				// subCategory: item.subCategory && item.subCategory,
				delimiter: payload.delimiter || ',',
				cronPattern: item.cronPattern || '*/1 * * * *',
				moveToState: item.moveToState && item.moveToState,
				// exclusionFolder: item.exclusionFolder && item.exclusionFolder,
				originalContentSplitter: item.originalContentSplitter || 'appendonsend',
				aliastoemail: item && item.aliastoemail,
				exclusionAutoReplies: item && item.exclusionAutoReplies,
				allowedDomains: item && item.allowedDomains,
				maxTryTicks: (item && item.maxTryTicks) || 5,
				skipTicks: (item && item.skipTicks) || 30,
			}
			if (payload.authType === 'password') {
				properties.password = hashedPassword
			} else if (payload.authType === 'oauth') {
				properties.oauth = {
					redirectUri: payload.redirectUri?.trim(),
					clientId: payload.clientId?.trim(),
					clientSecret: payload.clientSecret?.trim(),
					refreshToken: payload.refreshToken?.trim(),
					tenantId: payload.tenantId,
				}
			}
			payload.properties = properties
			item = payload
			removeObjectProperties(item, [
				'protocol',
				'hostName',
				'portNo',
				'timeOut',
				'password',
				'exclusionSubject',
				// 'successFolder',
				// 'failedFolder',
				'folderMapping',
				'caseFieldsMapping',
				'priorityMapping',
				'team',
				// 'reProcessFolder',
				'multiItem',
				// 'domain',
				// 'category',
				// 'subCategory',
				'delimiter',
				'cronPattern',
				'moveToState',
				// 'exclusionFolder',
				'originalContentSplitter',
				'queueName',
				'aliastoemail',
				'exclusionAutoReplies',
				'allowedDomains',
				'skipTicks',
				'maxTryTicks',
				'redirectUri',
				'clientId',
				'clientSecret',
				'refreshToken',
				'tenantId',
				'oauth',
				'authType',
			])
			return item
		} else {
			return item
		}
	}

	postActionsHooks({ actionName, item, tenantId }) {
		switch (actionName) {
			case 'getAll':
				let items =
					item &&
					item.map(i => {
						i = Object.assign({}, i, i.properties)
						i.protocol = i.properties.protocol
						i.hostName = i.properties.hostName
						i.team = i.properties.team
						i.portNo = i.properties.portNo
						i.timeOut = i.properties.timeOut
						i.queueName = i.properties.queueName
						i.maxTryTicks = i.properties.maxTryTicks
						i.skipTicks = i.properties.skipTicks
						i.multiItem = i.properties.multiItem
						i.password = i.properties.password
						if (i.authType === 'oauth') {
							i.redirectUri = i.properties && i.properties.oauth && i.properties.oauth.redirectUri
							i.clientId = i.properties && i.properties.oauth && i.properties.oauth.clientId
							i.refreshToken = i.properties.oauth?.refreshToken
							i.clientSecret = i.properties.oauth?.clientSecret
							i.tenantId = i.properties && i.properties.oauth && i.properties.oauth.tenantId
						}
						return i
					})
				return items
				case 'getOne':
					let i = item
					
					if(i && Object.keys(i).length>0){
							i = Object.assign({}, i, i.properties)
							i.protocol = i.properties.protocol
							i.hostName = i.properties.hostName
							i.team = i.properties.team
							i.portNo = i.properties.portNo
							i.timeOut = i.properties.timeOut
							i.queueName = i.properties.queueName
							i.maxTryTicks = i.properties.maxTryTicks
							i.skipTicks = i.properties.skipTicks
							i.multiItem = i.properties.multiItem
							i.password = i.properties.password
							if (i.authType === 'oauth') {
								i.redirectUri = i.properties && i.properties.oauth && i.properties.oauth.redirectUri
								i.clientId = i.properties && i.properties.oauth && i.properties.oauth.clientId
								i.refreshToken = i.properties.oauth?.refreshToken
								i.clientSecret = i.properties.oauth?.clientSecret
								i.tenantId = i.properties && i.properties.oauth && i.properties.oauth.tenantId
							}
						}
							return i
				case 'publishItem':
					let publishItem = item
					if(publishItem && Object.keys(publishItem).length>0){
						publishItem = Object.assign({}, publishItem, publishItem.properties)
						publishItem.protocol = publishItem.properties.protocol
						publishItem.hostName = publishItem.properties.hostName
						publishItem.team = publishItem.properties.team
							publishItem.portNo = publishItem.properties.portNo
							publishItem.timeOut = publishItem.properties.timeOut
							publishItem.queueName = publishItem.properties.queueName
							publishItem.maxTryTicks = publishItem.properties.maxTryTicks
							publishItem.skipTicks = publishItem.properties.skipTicks
							publishItem.multiItem = publishItem.properties.multiItem
							publishItem.password = publishItem.properties.password
							if (publishItem.authType === 'oauth') {
								publishItem.redirectUri = publishItem.properties && publishItem.properties.oauth && publishItem.properties.oauth.redirectUri
								publishItem.clientId = publishItem.properties && publishItem.properties.oauth && publishItem.properties.oauth.clientId
								publishItem.refreshToken = publishItem.properties.oauth?.refreshToken
								publishItem.clientSecret = publishItem.properties.oauth?.clientSecret
								publishItem.tenantId = publishItem.properties && publishItem.properties.oauth && publishItem.properties.oauth.tenantId
							}
						}
							return publishItem
			default:
				return item
		}
	}
}
